export class CurrentUserDto {
    public envidanPortalId!: number;
    public objectId!: string;
    public tenantId!: string;
    public hostCustomerId!: number;
    public firstName!: string;
    public lastName!: string;
    public email!: string;
    public isADLogin!: boolean;
}